// extracted by mini-css-extract-plugin
export default {"layout":"layout__f8d71cd4"};